import { Form, Formik } from "formik"
import React, { Fragment, useEffect, useId, useState } from "react"
import logger from "../../../Logger"
import { GetInitialFormValue, RenderFormGroups, getValidationSchema } from "./dynamic-form.helper"
import "./dynamic-form.scss"

const pageLogger = logger.child({ module: "Dynamic Form" })
const DynamicForm = (props) => {
  const {
    formData,
    initialValues,
    timeZones,
    currentTimeZone,
    setFormValid,
    submitButtonId,
    submitCallback,
    onUpdateCallback,
    formElementsTargetNode,
    groupTargets,
  } = props
  const [formInitialValue, setFormInitialValue] = useState(null)
  const [formValidations, setFormValidations] = useState(null)

  const shadowFormNodeId = useId() // DOM node id where 'sub form' may be rendered by child components outside the current Formik hierarchy

  useEffect(() => {
    const _initialVals = GetInitialFormValue({ formData, formValues: initialValues })
    setFormInitialValue(_initialVals)
    const _validations = getValidationSchema(formData)
    setFormValidations(_validations)
  }, [formData, initialValues])

  const handleErrors = (errors) => {
    setFormValid(Object.keys(errors).length > 0 ? false : true)
  }

  return (
    formInitialValue &&
    formValidations && (
      <div className="form-wrapper">
        <Formik
          enableReinitialize={true}
          initialValues={formInitialValue}
          validationSchema={formValidations}
          onSubmit={async (values, { setSubmitting }) => {
            pageLogger.info({ values }, `Submitting Values`)
            await submitCallback({ state: true, values })
            setSubmitting(false)
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (
            <Form className="game-detail-form">
              <div className={`layout`} data-layout={`${formData && formData.layout}`}>
                {formData && formData.layout_data && Array.isArray(formData.layout_data) && (
                  <div className="row">
                    {formData.layout_data.map((layoutData, dataIndex) => (
                      <Fragment key={`key-${dataIndex}-${layoutData.id}`}>
                        <div className={`col-${layoutData.layout_width || 12} layout-${dataIndex}`}>
                          {RenderFormGroups(
                            layoutData.groups,
                            values,
                            touched,
                            errors,
                            timeZones,
                            shadowFormNodeId,
                            formElementsTargetNode,
                            groupTargets
                          )}
                        </div>
                      </Fragment>
                    ))}
                  </div>
                )}
                {onUpdateCallback?.({ values, touched, errors, isSubmitting })}
                {/* <hr /> */}
                {handleErrors(errors)}
                {/* <hr /> */}
                {/* VALUES:
                <pre>{JSON.stringify(values, null, 2)}</pre> */}
                {/* <pre>{pageLogger.info({ values }, "Dynamic form Values")}</pre> */}
                {/* TOUCHED:
                <pre>{JSON.stringify(touched, null, 2)}</pre> */}
                {/* ERRORS
                <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                <button type="submit" id={`${submitButtonId}`} className="no-print" disabled={isSubmitting} style={{ display: "none" }}>
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <div id={shadowFormNodeId}></div>
      </div>
    )
  )
}

DynamicForm.propTypes = {}

export default DynamicForm
